import styled from 'styled-components';

export const Radio = styled.input.attrs({ type: 'radio' })`
  margin-right: ${({ theme }) => theme.spacings.sm};
  width: 20px;
  height: 20px;
`;
